import script from "./SharedCardUndanews.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedCardUndanews.vue?vue&type=script&setup=true&lang=js"

import "./SharedCardUndanews.vue?vue&type=style&index=0&id=13ee6038&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ee6038"]])

export default __exports__